// extracted by mini-css-extract-plugin
export var calendarView = "_ip-0";